
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class SalesReturnMasterDialog extends _Ext.TransDialog<SalesReturnMasterRow, any> {

        protected getFormKey() { return SalesReturnMasterForm.formKey; }
        protected getIdProperty() { return SalesReturnMasterRow.idProperty; }
        protected getLocalTextPrefix() { return SalesReturnMasterRow.localTextPrefix; }
        protected getNameProperty() { return SalesReturnMasterRow.nameProperty; }
        protected getService() { return SalesReturnMasterService.baseUrl; }
        protected getDeletePermission() { return SalesReturnMasterRow.deletePermission; }
        protected getInsertPermission() { return SalesReturnMasterRow.insertPermission; }
        protected getUpdatePermission() { return SalesReturnMasterRow.updatePermission; }
        protected useViewMode() { return true; }
        public form = new SalesReturnMasterForm(this.idPrefix);
        
        contractTotals: string;
        TaxRegistred: number;
        TaxArray: any[];
        public Closing: boolean;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public CurrencyId: number;
        //ProdctImage of Items
        static image: string;
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 290;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            //Make grid full width
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorLabel(this.form.TaxDetails);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.RoundOff);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.TaxAmount);
            q.setGridEditorHeight(this.form.ItemDetails, 300);
            q.setGridEditorHeight(this.form.TaxDetails, 150);
            //To Hide Image Toolbar & Label
            q.hideImageToolbar(this.form.ProductItemImage);
            q.hideEditorLabel(this.form.ProductItemImage);

            //To Show Image on Right Top & Hide Categories
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryTwoColumn(this.form.ProductItemImage);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.TaxDetails);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element);
            this.form.LedgerName.getGridField().find('.caption').attr('Style', 'display:none');

            this.form.TaxDetails.getGridField().find('.grid-toolbar').attr("style", "display:none;");
            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });


            // **** Get Party Details using PartyID **** 
            this.form.PartyId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.PartyId.value)) {

                    let PartyDetails: OMS.CustomerRow;
                    OMS.CustomerService.Retrieve({ EntityId: this.form.PartyId.value }, response => { PartyDetails = response.Entity }, { async: false });
                    this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                    this.form.ItemDetails.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                    this.form.ItemDetails.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                    this.form.ItemDetails.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                    this.form.ItemDetails.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                    //this.form.City.value = PartyDetails.City;
                    this.form.LedgerName.value = PartyDetails.LedgerName;
                    this.form.GstVat.value = PartyDetails.GstVat;

                    let AddressDetails: OMS.AddressMasterRow;
                    OMS.AddressMasterService.GetAddress({
                        LedgerId: parseInt(this.form.PartyId.value)
                    },
                        response =>
                            AddressDetails = response.Entity,
                        { async: false }
                    );

                    if (AddressDetails != null) {
                        this.form.State.value = AddressDetails.StateName;
                        this.form.Country.value = AddressDetails.CountryName;
                        var city = AddressDetails.CityName;
                        let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                            + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                        this.form.Address1.value = address;

                    }
                }
            });

            this.form.CurrencyId.changeSelect2(e => {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            });

            this.form.RoundOff.changeSelect2(e => {
                this.form.GrossAmount.value = this.form.GrossAmount.value + this.form.RoundOff.value;
            });
            //Load Image after Row in Details is Clicked
            var _this = this;
            this.form.ItemDetails.slickGrid.onClick.subscribe(function (e, args) {

                var x: Serenity.UploadedFile = {
                    Filename: SalesReturnMasterDialog.image,
                    OriginalName: ""
                }
                _this.form.ProductItemImage.value = x;//POSSalesDialog.image;

                //Set Image Width & Height

                q.setImageEditorHeight(_this.form.ProductItemImage, 160);
            });

            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any;

            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => { 
                Items = this.form.ItemDetails.getItems();

                var TotalItems = this.form.ItemDetails.getItems().length; 
                 
                if (Items.length == TotalItems) {

                    this.CalculateAmountandTax(Items,  TotalItems);
                }
                
            });

            this.form.GrossAmount.addValidationRule(this.uniqueName, e => {
                //Validate Sales Item is Added or not
                if (this.form.ItemDetails.getItems().length == 0) {
                    Q.notifyWarning('No Sales Items Selected to Return')
                    return ""
                }
            });
            this.validateForm();
        }

        onDialogClose() {
            this.Closing = true;

        }

        public CalculateAmountandTax(Items: any,  TotalItems: number) {

            var HSN = [];
            var Amount = [];
            var TaxDetail = [];
            var ItemTotal = 0;
            var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var wt = 0; var nwt = 0; var tds = 0;

            for (var x of Items) {
                ntamt += x.NetAmount || 0;
                gramt += x.GrossAmount || 0;
                disc += x.Discount || 0;
                pcs += x.Pieces || 0;
                wt += x.Weight || 0;
                nwt += x.NetWeight || 0;

                var temp = false;
                for (let i = 0; i < HSN.length; i++) {
                    if (HSN[i] == x.TaxCode) {
                        Amount[i] += x.GrossAmount || 0;
                        temp = true;
                    }
                }

                if (!temp) {
                    HSN.push(x.TaxCode);
                    Amount.push(x.GrossAmount);
                }
                ItemTotal++;
            };

            this.form.NetAmount.value = gramt;
            this.form.Discount.value = disc;

            var TaxAmount = 0;

            var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == this.form.VoucherTypeId.value)[0].IsTaxApplicable;

            if (ItemTotal == TotalItems && TaxApplicable) {

                var TaxItems = this.form.TaxDetails.getItems().length;
                var it = this.form.TaxDetails.getItems();
                if (TaxItems > 0) {
                    this.form.TaxDetails.DeleteTax();
                }
                 
                var Cmpstate = OMS.CompanyRow.getLookup().itemById[Q.Authorization.userDefinition.CompanyId].State;

                //TODO: Get Company Country to Call appropriate TAX Helper
                if (this.TaxRegistred != 290 && this.TaxRegistred != 288) {
                    if (this.form.State.value == Cmpstate) {
                        TaxDetail = TaxHelper.NewTaxCalculation(HSN, Amount, this.form.TransDate.value, false, 0);
                        TaxDetail = TaxHelper.VoucherTaxCalculation(this.form.VoucherTypeId.value, gramt, this.form.TransDate.value, TaxDetail, false);
                    }
                    else {
                        TaxDetail = TaxHelper.NewTaxCalculation(HSN, Amount, this.form.TransDate.value, true, 0);
                        TaxDetail = TaxHelper.VoucherTaxCalculation(this.form.VoucherTypeId.value, gramt, this.form.TransDate.value, TaxDetail, true);
                    }

                    var temp2 = this.form.TaxDetails.getData(TaxDetail);
                    this.form.TaxDetails.view.setItems(temp2, true);

                    TaxDetail.forEach(function (value) {
                        if (value.TaxType != "TDS")
                            TaxAmount += value.TaxAmount;
                        else
                            tds += value.TaxAmount;
                    });
                }

                this.form.TaxAmount.value = TaxAmount;
                this.form.GrossAmount.value = gramt + TaxAmount;
                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt;
            }
            else {
                this.form.GrossAmount.value = gramt;
                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt;
            }
        }

        protected onDialogOpen() {
            super.onDialogOpen();

            if (this.form.PartyId.value != "") {
                let PartyDetails;
                OMS.CustomerService.Retrieve({
                    EntityId: parseInt(this.form.PartyId.value)
                }, response => {
                    PartyDetails = response.Entity
                }, { async: false });
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.ItemDetails.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                this.form.ItemDetails.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                this.form.ItemDetails.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                this.form.ItemDetails.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                //this.form.City.value = PartyDetails.City;
                this.form.LedgerName.value = PartyDetails.LedgerName;
                this.form.GstVat.value = PartyDetails.GstVat;
                let AddressDetails: OMS.AddressMasterRow;
                OMS.AddressMasterService.GetAddress({
                    LedgerId: parseInt(this.form.PartyId.value)
                },
                    response =>
                        AddressDetails = response.Entity,
                    { async: false }
                );

                if (AddressDetails != null) {
                    this.form.State.value = AddressDetails.StateName;
                    this.form.Country.value = AddressDetails.CountryName;
                    var city = AddressDetails.CityName;
                    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                    this.form.Address1.value = address;

                }

                var items = this.form.ItemDetails.getItems();
                let pieces = [];
                let weight = [];
                let itemids = [];
                items.forEach(function (value) {
                    itemids.push(value.TransItemId);
                    pieces.push(value.Pieces);
                    weight.push(value.Weight);
                });
                this.form.ItemDetails.itemids = itemids;
                this.form.ItemDetails.pieces = pieces;
                this.form.ItemDetails.weight = weight;
                this.form.ItemDetails.isUpdate = 1;
                this.form.ItemDetails.canUpdate = 0;
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, true);

            }
            else {

                this.form.GrossAmount.value = 0;
                this.form.ItemDetails.isUpdate = 0;
            }
          

            var fieldEditor: JQuery = this.form.PartyId.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
        }

        protected inplaceSearchClick(e: any): void {
            var grid = OMS.CustomerGrid;
            var pickerDialog = new _Ext.GridItemPickerDialog({
                gridType: grid, multiple: false, title: "Select Customer"
            });

            pickerDialog.onSuccess = (selectedItems: OMS.CustomerRow[]) => {

                this.form.PartyId.value = selectedItems[0].LedgerId.toString();
                this.form.LedgerName.value = selectedItems[0].LedgerName;

                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.LedgerName.value = selectedItems[0].LedgerName;
                this.form.ItemDetails.RateListId = selectedItems[0].CostPricegroupId == null ? 0 : selectedItems[0].CostPricegroupId;
                this.form.ItemDetails.StoneMarkup = selectedItems[0].StnAddMkp == null ? 0 : selectedItems[0].StnAddMkp;
                this.form.ItemDetails.LaborMarkup = selectedItems[0].LbrAddMkp == null ? 0 : selectedItems[0].LbrAddMkp;
                this.form.ItemDetails.LaborListId = selectedItems[0].LbrPricegroupId == null ? 0 : selectedItems[0].LbrPricegroupId;
                this.TaxRegistred = parseInt(selectedItems[0].TaxRegType);

                this.form.GstVat.value = selectedItems[0].GstVat;

                let AddressDetails: OMS.AddressMasterRow;
                OMS.AddressMasterService.GetAddress({
                    LedgerId: parseInt(this.form.PartyId.value)
                },
                    response =>
                        AddressDetails = response.Entity,
                    { async: false }
                );

                if (AddressDetails != null) {
                    this.form.State.value = AddressDetails.StateName;
                    this.form.Country.value = AddressDetails.CountryName;
                    var city = AddressDetails.CityName;
                    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                    this.form.Address1.value = address;

                }
            }
            pickerDialog.dialogOpen();

        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };

            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'Sales.SalesReturnVoucher',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));


            var postingpermission = Q.Authorization.hasPermission('Sales:Return:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;
                 
                    SalesReturnMasterService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });

            return btns;
        }


        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                this.form.ItemDetails.canUpdate = 1;
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                SalesReturnMasterService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }
        validateBeforeSave() {
            let Isvalid = super.validateBeforeSave();
            Isvalid = ValidateTransaction(this.form.ItemDetails.getItems(), this.form.Pieces.value, this.form.Weight.value);
            return Isvalid;
        }
     }
}